import { t } from "../../../../../../utils/i18n";
import React from "react";
import _ from "lodash";
import PersonalDetails from "./components/PersonalDetails";
import IdentificationDetails from "./components/IdentificationDetails";
import MailingDetails from "./components/MailingDetails";
import {
  personalDetails,
  identificationDetails,
  mailingDetails,
} from "./helpers";
import { CardType } from "../../Types";

interface Props {
  data: any;
  cardType: string;
  physicalCardTypes: CardType[];
  virtualCardTypes: CardType[];
  submitting: boolean;
  handleSetStep: (step: string) => void;
  isMultiRequest: boolean;
}

const Preview: React.FC<Props> = ({
  cardType,
  physicalCardTypes,
  virtualCardTypes,
  data,
  handleSetStep,
  submitting,
  isMultiRequest,
}) => {
  const onClickEdit = (e, step) => {
    e.preventDefault();
    handleSetStep(step);
  };

  const cardTypeInfo =
    cardType === "virtual"
      ? virtualCardTypes.find((card) => card.type === cardType)
      : physicalCardTypes.find((card) => card.type === cardType);

  return (
    <div className="card-body">
      <div id="preview">
        <div className="card-subheader-bg">
          <h4 className="card-subheader-bg-font">{t("cards.request_form.preview")}</h4>
          <p className="card-subheader-bg-description">
            {t("cards.request_form.please_confirm_all_your_details_have")}
          </p>
        </div>
        <br />
        <div className="form-horizontal">
          <div className="card-inner-container ">
            <h6 className="card-sub-title ">{t("cards.request_form.card_details")}</h6>
            <div className="form-group row">
              <label className="col-12 col-md-3 form-label card-sub-title">
                {t("cards.request_form.card_type")}
              </label>
              <div className="col-12 col-md-9">
                <span>{_.startCase(_.toLower(cardType))}</span>
              </div>
            </div>
            <div className="form-group row">
              <label className="col-12 col-md-3 form-label card-sub-title">
                {t("cards.request_form.application_fee")}
              </label>
              {cardTypeInfo.is_coupon_claimable ? (
                <div className="col-12 col-md-9">
                  <span style={{ textDecoration: "line-through" }}>
                    ${cardTypeInfo.application_fee}
                  </span>{" "}
                  <span>${cardTypeInfo.discounted_fee}</span>
                  <span>({t("cards.request_form.coupon", { code: cardTypeInfo.coupon_code })})</span>
                </div>
              ) : (
                <div className="col-12 col-md-9">
                  <span>${cardTypeInfo.application_fee}</span>
                </div>
              )}
            </div>
          </div>
          <hr />
          {!isMultiRequest && (
            <>
              <PersonalDetails
                onClickEdit={onClickEdit}
                cardType={cardType}
                data={personalDetails(data)}
              />
              <>
                <hr />
                <IdentificationDetails
                  onClickEdit={onClickEdit}
                  data={identificationDetails(data)}
                />
              </>
            </>
          )}
          <hr />
          <MailingDetails
            onClickEdit={onClickEdit}
            data={mailingDetails(data)}
          />
          <hr />
        </div>
        <div className="d-flex flex-row justify-content-between">
          <div className="ml-auto">
            <button
              type="submit"
              className="btn btn-purple  float-right"
              disabled={submitting}
            >
              {submitting && (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
              {t("cards.request_form.submit")} <i className="fa fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preview;
